import React from "react";
import {Route, Switch} from "react-router-dom";
import asyncComponent from "shared/General/components/AsyncComponent/AsyncComponent";

const AsyncFreshersApp = asyncComponent(() => import("../modules/SignUp/SignUp"));

const FreshersRouter = () => (
    <Switch>
        <Route path="/freshers/:universitySlug" component={AsyncFreshersApp} />
    </Switch>
);

export const fresherPaths = ["/freshers"];

export default FreshersRouter;
